import { ReactElement } from 'react'
import { Button, Stack } from '@mui/material'
import { useStructuralPlanningSelection } from '@structuralPlanningHooks'

interface Props {
  onClose?: () => void
  /** Replaces clearing the whole selection, e.g. to drop only an opening sub-selection. */
  onDeselect?: () => void
}

const StructuralPlanningDeselectButton = ({ onClose, onDeselect }: Props): ReactElement => {
  const {
    actions: { resetElements },
  } = useStructuralPlanningSelection()

  return (
    <Stack direction="row" justifyContent="end" spacing={1}>
      <Button
        variant="outlined"
        onClick={() => {
          if (onDeselect) onDeselect()
          else resetElements()
          onClose?.()
        }}
        size="small"
        fullWidth
        data-cy="btn-unselect"
      >
        abwählen
      </Button>
    </Stack>
  )
}

export default StructuralPlanningDeselectButton
